import { Store } from 'utils';

class SelectedStandStore extends Store {

    getInitialState() {
        return {
            selected: null
        }
    }
	
    onSelectedStandChanged(state, data) {
        state.selected = data;
    }

}

const store = new SelectedStandStore();
export default store;


// WEBPACK FOOTER //
// ./src/modules/model/SelectedStandStore.js